export default __webpack_public_path__ + "static/media/Paso1.6d24aa74.svg";